<h1 *ngIf="!isAppMobile" tabindex="-1" class="dsd-t-3 dsd-mt-md">{{ titre | translate }}</h1>
<dsd-container class="conteneur-margin" *ngIf="requeteModifierCoordonnees">
  <app-valider-coordonnees
    *ngIf="isCoordonnees()"
    [requeteModifierCoordonnees]="requeteModifierCoordonnees"></app-valider-coordonnees>
  <app-valider-telephone
    *ngIf="isTelephone()"
    [requeteModifierCoordonnees]="requeteModifierCoordonnees"></app-valider-telephone>
  <app-valider-courriel
    *ngIf="isCourriel()"
    [requeteModifierCoordonnees]="requeteModifierCoordonnees"></app-valider-courriel>
</dsd-container>

<div class="zone-btn">
  <dsd-button class="modifier-btn first" variant="primary" (dsdButtonClick)="submit()" fullWidth="xs">{{
    'caad.button.confirmer' | translate
  }}</dsd-button>
  <dsd-button class="modifier-btn middle" (dsdButtonClick)="retourForm()" fullWidth="xs">{{
    'caad.button.modifier' | translate
  }}</dsd-button>
  <dsd-button class="modifier-btn" (dsdButtonClick)="annulerModification()" fullWidth="xs">{{
    'caad.button.annuler' | translate
  }}</dsd-button>
</div>
